import { useState, useEffect } from 'react';

export const useGeolocationPermission = () => {
  const [navigationPermission, setNavigationPermission] = useState<
    PermissionState | undefined
  >(undefined);

  useEffect(() => {
    const checkGeolocationPermission = async () => {
      try {
        const permissionStatus = await navigator.permissions.query({
          name: 'geolocation' as PermissionName,
        });

        const handlePermissionChange = () => {
          setNavigationPermission(permissionStatus.state);
        };

        permissionStatus.onchange = handlePermissionChange;

        handlePermissionChange();
      } catch (error) {
        console.error('Error checking geolocation permission:', error);
      }
    };

    checkGeolocationPermission();
  }, []);

  return navigationPermission;
};
